<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('event.form.person.title') }}</span>
          
          <div class="float-right" >
            <a href="#eventPerson" name="eventPerson" @click="addEventPerson"  v-if="compMode != CRUDMODE.READ">
              <span class="fa fa-plus fa-lg"></span>
            </a>
            &nbsp;
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table id="dataTableEventPerson" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="200">{{ $t('event.form.person.type') }}</th>
                  <th>{{ $t('event.form.person.name') }}</th>
                  <th width="50">{{ $t('event.form.person.presence') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th width="200">{{ $t('event.form.person.type') }}</th>
                  <th>{{ $t('event.form.person.name') }}</th>
                  <th width="50">{{ $t('event.form.person.presence') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="eventPersons.length == 0">
                  <td valign="top" colspan="4" class="dataTables_empty">{{ $t("form.aucun_donne") }}</td>
                </tr>

                <tr v-for="(item, index) in eventPersons" v-bind:data-id="item.id" :key="item.id">
                  
                  <td>
                    <select v-model="item.personType" :data-vv-name="'personType' + index"
                        v-validate="'required'" class="form-control" id="typeInput" :placeholder="$t('event.form.person.type')">
                        <option v-for="s in personTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                    </select>
                    <span class="text-danger" v-if="errors.has('personType'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td>
                    <member-multiselect v-if="item.personType == 1" :members="members" :model="item.member" @update="f=> changeValue(index, 'member', f)"></member-multiselect>
                    
                    <user-multiselect v-if="item.personType == 2" :model="item.associatedUser" @update="f=> changeValue(index, 'associatedUser', f)"></user-multiselect>
                    
                    <entrepreneur-multiselect v-if="item.personType == 3" :model="item.entrepreneur" @update="f=> changeValue(index, 'entrepreneur', f)"></entrepreneur-multiselect>
                    
                    <partner-multiselect v-if="item.personType == 4"  :model="item.partner" @update="f=> changeValue(index, 'partner', f)"></partner-multiselect>
                  </td>
                  <td>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" name="present"  value="1" class="custom-control-input" id="present" v-model="item.present">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-label">Oui</span>
                    </label>
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#person" v-on:click="removeEventPerson(index)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="float-right" >
                <a @click="exportInscriptions" v-if="eventPersons.length != 0" id="exportInscriptions" class="btn btn-primary">
                  {{ $t('event.form.person.exportInscriptions') }}
                </a>
                &nbsp;
                <a @click="exportPresences" v-if="eventPersons.length != 0" id="exportPresences" class="btn btn-primary">
                  {{ $t('event.form.person.exportPresences') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventServiceClient, EventPersonDto, PartnerServiceClient, MemberServiceClient} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import MemberMultiselect from '../../shared/multiselect/MemberMultiselect'
  import EntrepreneurMultiselect from '../../shared/multiselect/EntrepreneurMultiselect'
  import UserMultiselect from '../../shared/multiselect/UserMultiselect'
  import PartnerMultiselect from '../../shared/multiselect/PartnerMultiselect'

  export default {
    name: 'CreateEventPerson',
    props: {
      eventPersons: {},
      members: {
        type: Array,
        default: [],
      },
      members: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        personTypes: [],
        localVisible: true,
      }
    },
    inject: ['$validator'],
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      exportInscriptions: function() {
        let list = this.eventPersons
        this.export(list, 'inscriptions')
      },
      exportPresences: function() {
        let list = _.filter(this.eventPersons, f => f.present)
        this.export(list, 'presences')
      },
      export: function(list, name) {
        let csvContent =
          this.$t('event.form.person.type') +
          ';' +
          this.$t('event.form.person.firstname') +
          ';' +
          this.$t('event.form.person.lastname') +
          ';' +
          this.$t('event.form.person.email') +
          ';' +
          this.$t('event.form.person.phone') +
          ';' +
          this.$t('event.form.person.officePhone') +
          ';' +
          this.$t('event.form.person.cellPhone') +
          '\r\n'

        let self = this

        list.forEach(function(item) {
          let row = ''
          if (item.personType == 1 && item.member != null) {
            row =
              self.$t('event.form.person.member') +
              ';' +
              item.member.name +
              '; ' +
              item.member.familyName +
              '; ' +
              item.member.email +
              '; ' +
              (item.member.phone != null ? item.member.phone : 'non-défini') +
              '; ' +
              (item.member.officePhone != null ? item.member.officePhone + ' #' + item.member.officePhoneExtension : 'non-défini') +
              ';' +
              item.member.cellphone +
              '; '
          } else if (item.personType == 2 && item.associatedUser != null) {
            row =
              self.$t('event.form.person.user') +
              ';' +
              item.associatedUser.lastName +
              ', ' +
              item.associatedUser.firstName +
              '; ' +
              item.associatedUser.emailAddress +
              '; ' +
              item.associatedUser.phoneNumber +
              '; ;'
          } else if (item.personType == 3 && item.entrepreneur != null) {
            row =
              self.$t('event.form.person.entrepreneur') +
              ';' +
              item.entrepreneur.name +
              ', ' +
              item.entrepreneur.familyName +
              '; ' +
              item.entrepreneur.email +
              '; ' +
              item.entrepreneur.phone +
              '; ' +
              (item.entrepreneur.officePhone != null
                ? item.entrepreneur.officePhone + ' #' + item.entrepreneur.officePhoneExtension + '; '
                : '') +
              item.entrepreneur.cellphone
          } else if (item.personType == 4 && item.partner != null) {
            row = self.$t('event.form.person.partner') + ';' + '(' + item.partner.name + ') '

            if (item.partner.partnerContact != null && item.partner.partnerContact.length > 0) {
              row +=
                item.partner.partnerContact[0].name +
                ', ' +
                item.partner.partnerContact[0].familyName +
                '; ' +
                item.partner.partnerContact[0].email +
                '; ' +
                item.partner.partnerContact[0].phone +
                '; ;'
            } else {
              row += ';;;;'
            }
          }
          csvContent += row + '\r\n'
        })

        this.download(csvContent, name + '.csv', 'text/csv;encoding:UTF-8')
      },
      changeValue: function(index, field, value) {
        this.eventPersons[index][field] = value
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      fetchData: function() {
        let self = this
        let eventService = ServiceFactory.create(EventServiceClient)
        eventService.getEventPersonType().then(res => {
          self.personTypes = _.filter(res, f => f.item1 != 0)
        })
      },
      addEventPerson: function() {
        let dto = new EventPersonDto()
        dto.init({})
        this.eventPersons.push(dto)
      },
      removeEventPerson: function(index) {
        this.eventPersons.splice(index, 1)
      },
    },
    components: {
      MemberMultiselect,
      EntrepreneurMultiselect,
      UserMultiselect,
      PartnerMultiselect,
    },
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/events/CreateEventPerson.vue